import { ActionType, ActionTypes, OAuthData } from './types';

const initialState = {
  isAuthenticated: false,
  token: undefined,
  isLogin: false,
  expires: Date.now(),
  refresh: undefined,
  userId: undefined,
  cookies: null,
  serverDown: false,
  idled: undefined,
};

const authReducer = (state: OAuthData = initialState, action: ActionType): OAuthData => {
  switch (action.type) {
    case ActionTypes.AUTHORIZE_USER:
      return {
        ...state,
        ...action.payload,
      };
    case ActionTypes.AUTHORIZE_CLIENT:
      return {
        ...state,
        ...action.payload,
      };
    case ActionTypes.SET_USERID:
      return {
        ...state,
        userId: action.payload,
      };
    case ActionTypes.SET_COOKIES:
      return {
        ...state,
        cookies: action.payload,
      };
    case ActionTypes.SET_SERVER_DOWN:
      return {
        ...state,
        serverDown: action.payload,
      };
    case ActionTypes.SET_IDLED:
      return {
        ...state,
        idled: action.payload,
      };
    case ActionTypes.LOGOUT_USER:
      return initialState;
    default:
      return state;
  }
};

export default authReducer;
